<template>
  <hr :class="classes">
</template>

<script>
  const SIZES = ['large', 'medium', 'small'];

  export default {
    name: 'CordelContextSeparator',
    props: {
      size: {
        type: String,
        default: SIZES[0],
        validator(value) {
          return SIZES.includes(value);
        },
      },
    },
    computed: {
      classes() {
        return [
          'cordel-separator',
          `size--${this.size}`,
        ];
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .cordel-separator {
    appearance: none;
    background-color: var(--cordel-legacy-color-constant-dark);
    background-image: none;
    border: none;
    border-radius: 0;
    box-shadow: none;
    display: block;
    height: var(--cordel-legacy-border-width-thin);
    margin: var(--cordel-legacy-spacing-blaster) 0;

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin: var(--cordel-legacy-spacing-giga) 0;
    }
  }

  .size--medium {
    margin: var(--cordel-legacy-spacing-giga) 0;
  }

  .size--small {
    margin: var(--cordel-legacy-spacing-s) 0;
  }
</style>
